export default import.meta.ROLLDOWN_FILE_URL_5gcq5el_hCCFrIB2p2yjiQ